<template>
  <form :id="id" @submit.prevent="handleSubmit"></form>
</template>

<script setup lang="ts">
import {
  type PaymentFormAdapterEmits,
  type PaymentFormAdapterExpose,
  type PaymentFormAdapterProps,
  PaymentSubmitError,
  type SubmitSuccessData,
} from '../../../form-common/types'

import ApplePayButton from './ApplePayButton/ApplePayButton.vue'

defineExpose<PaymentFormAdapterExpose>({
  // We want to show a custom Apple Pay submit button
  ...(window.CSS.supports('-webkit-appearance', '-apple-pay-button')
    ? { submitButton: { is: ApplePayButton } }
    : {}),
})

const props = defineProps<PaymentFormAdapterProps>()
const emit = defineEmits<PaymentFormAdapterEmits>()

const handleSubmit = async () => {
  emit('submit-start')
  try {
    // TODO [PAYIN-3145] Implement the Apple Pay adapter
    const result = await props.createPayment()

    // We know that the API will return a redirectLink,
    // so we can safely cast the result to SubmitSuccessData
    emit('submit-success', result as SubmitSuccessData)
  } catch (error) {
    emit('submit-error', PaymentSubmitError.fromAnyError(error))
  }
}
</script>
